'use strict';

angular.module('atex.art').factory('CrossSearchService', ['$q', 'ContentService', 'FactoryService', '$injector',
 function ($q, ContentService, FactoryService, $injector) {

  var _providers = [];
  var _providersGetPromise = undefined;

  var partitionsConf;

  var checkParenthesis = function (q) {
    var count = 0;
    if (!q) {
      return true;
    }
    for (var i = 0; i < q.length; i++) {
      if (q[i] === '(') {
        count++;
      } else if (q[i] === ')') {
        if (count === 0) {
          return false;
        }
        count--;
      }
    }
    return count === 0;
  };

  var checkDoubleQuotes = function (q) {
    if (!q) {
      return true;
    }
    var count = (q.match(/"/g) || []).length;
    return count % 2 === 0;
  };

  function _checkQueryString(q) {
    if (!q) {
      return true;
    }
    var tq = q.trim();
    if (!tq) {
      return true;
    }

    if (tq === "AND" || tq === "&&" || tq === "OR" || tq === "||" ||
      tq === "NOT" || tq === "!" || tq === "+" || tq === "-" ||
      tq.match(/^AND /) || tq.match(/ AND$/) ||
      tq.match(/^&& /) || tq.match(/ &&$/) ||
      tq.match(/^OR /) || tq.match(/ OR$/) ||
      tq.match(/^\|\| /) || tq.match(/ \|\|$/) ||
      tq.match(/ NOT$/) ||
      tq.match(/ !$/) ||
      tq.match(/ \+$/) ||
      tq.match(/ \-$/) || !checkParenthesis(tq) || !checkDoubleQuotes(tq)) {
      return false; // NOT Valid solr query String
    }

    return true;
  }

  return {

    getProviders: function () {
      if (_providers.length > 0) {
        return $q.when(_providers);
      } else if (_providersGetPromise) {
        return _providersGetPromise;
      }
      var transferInfo = {id: 'p.onecms.CrossSearchProvidersList'};
      _providersGetPromise = ContentService.getContent(transferInfo).then(function (responseInfo) {
        var promises = responseInfo.data.aspects.contentData.data.contentsContentList.list.map(function (entry) {
          return ContentService.getContent({id: entry.contentId}).then(function (response) {
            // Get The externalId of the factory
            var extId = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/atex.Aliases/data/aliases/externalId');
            return FactoryService.getFactory(extId).then(function (factory) {
              return $injector.instantiate($injector.get(factory.factoryName));
            });
          });
        });
        return $q.all(promises).then(function (providers) {
          _providers = providers;
          return providers;
        });
      }).then(null, function (error) {
        console.log('ERROR: Getting p.onecms.CrossSearchProvidersList:', error);
        return $q.reject(error);
      });
      return _providersGetPromise;
    },

    checkQueryString: function (q) {
      return _checkQueryString(q);
    },

    getPartitionsConf: function() {
      if (partitionsConf) {
        return $q.when(partitionsConf);
      }
      partitionsConf = ContentService.getContent({'id': 'dam.partitions.conf'}).then(function(resp){
        if (resp.data.aspects.contentData.data.partitions && resp.data.aspects.contentData.data.partitions.length > 0) {
          var partObj = [];
          resp.data.aspects.contentData.data.partitions.forEach(function(partition){
            partObj[partition.partition] = {
              "label": partition.label,
              "icon": partition.icon,
              "color": partition.color
            };
          });
          partitionsConf = partObj;
          return partitionsConf;
    }
      });
      return partitionsConf;
    }

  };
}]);

angular.module('atex.art').factory('CrossSearchResult', [
  function () {

    function CrossSearchResult(appName) {
      this.id = '';
      this._type = '';
      this.desc = '';
      this.thumbUrl = '';
      this.name = '';
      if (!appName) {
        console.log("Please Provide appName creating CrossSearchResult!!!");
      }
      this.appName = appName;
    }

    // Return the constructor function
    return CrossSearchResult;
  }
]);

angular.module('atex.art').directive('crossSearchResult', ['$http', 'Application',
  function ($http, Application) {
  return {
    restrict: 'E',
    replace: true,
    template: [
      '<div class="cross-search-result" draggable="true">',
        '<img class="csr-img thumbnail" ng-if="entry.thumbUrl" ng-src="{{entry.thumbUrl}}" />',
      '<span class="csr-head" ng-attr-title="getTitleOrName(entry)">{{getTitleOrName(entry)}}</span>',
        '<span class="text" ng-if="entry.desc" ng-attr-title="{{entry.desc.length>maxDescLen ? entry.desc : undefined}}" ng-bind-html="to_trusted(entry.desc, maxDescLen, false)"><span ng-if="entry.desc.length>maxDescLen">...</span></span>',
      '<span class="text" ng-if="getNameIfDifferent(entry)" ng-attr-title="getNameIfDifferent(entry)">{{getNameIfDifferent(entry)}}<br></span>',
        '<br><span class="text" ng-if="isSourceVisible(entry.partition)" ng-attr-title="{{entry.source.length>maxDescLen ? entry.source : undefined}}" ng-bind-html="getFilteredSource(entry)"></span>',
        '<br><span class="text" ng-if="isFieldSet(entry.author)" ng-attr-title="{{entry.author.length>maxDescLen ? entry.author : undefined}}" ng-bind-html="getFieldText(entry.author)"></span>',
        '<div class="ref-box" ng-if="entry.ref" ng-attr-title="{{to_trusted(entry.ref, maxDescLen, false)}}" ng-bind-html="to_trusted(entry.ref, 0, true)"></div>',
        '<div class="csr-foot">',
          '<span class="valign"><i ng-class="iconClass"></i>&nbsp;</span>',
          '<span class="valign"><i ng-if="partIconClass" style="color:{{partIconColor}}" ng-class="partIconClass"></i>&nbsp;</span>',
          '<span ng-if="entry.webstatus" class="text">&nbsp;<u>{{entry.webstatus}}</u>&nbsp;</i></span>',
          '<span class="valign">{{entry.typeLabel || entry.type}}</span>',
          '<span class="valign">&nbsp;<i class="fa fa-globe" ng-if="entry.isPublished && !entry.isOffline" style="color:blue"></i></span>',
          '<span class="text" style="vertical-align: middle;" ng-if="isFieldSet(entry.pubdate)" ng-attr-title="{{entry.pubdate.length>maxDescLen ? entry.author : undefined}}" ng-bind-html="getFieldDate(entry.pubdate)"></span>',
          '<span class="valign" ng-if="entry.isPublished && entry.isOffline" style="color:gray;font-size:smaller">&nbsp;OFFLINE</span>',
          '<span ng-if="entry.canCopy" class="csr-foot-btn valign">' +
            '&nbsp;<button   ng-click="copy()">',
              '<i ng-show="!copying" class="fa fa-files-o"></i>',
              '<i ng-show="copying" class="fa fa-spinner"></i>',
            '</button>',
          '</span>',
          '<span class="time-span valign" ng-if="entry.time"><b>{{entry.timeLabel}}: </b>{{entry.time}}</span>',
        '</div>',
      '</div>'
    ].join(''),

    scope: {
      provider: "=",
      entry: "="
    },

    controller: function ($scope, ClipboardService, CrossSearchResult, $filter, $sce, preloader, CrossSearchService, $translate) {
      $scope.maxNameLen = 55;
      $scope.maxDescLen = 150;

      var imageLocations = ["img/video.png", "img/embed.png", "img/image.png", "img/article.png", "img/generic.png"];
      preloader.preloadImages(imageLocations).then(function() {
        $scope.iconClass = $scope.provider.getIconByEntryType($scope.entry);
        if ($scope.entry.partition) {
          CrossSearchService.getPartitionsConf().then(function (partConf) {
            if (partConf && partConf[$scope.entry.partition]) {
              $scope.partIconClass = partConf[$scope.entry.partition].icon;
              $scope.partIconColor = partConf[$scope.entry.partition].color;
            }
          });
        }
      });

      $scope.getTitleOrName = function(entry) {
        var res;
        if (entry.headline && entry.headline.text === undefined && entry.headline !== undefined && entry.headline !== ""){
          res = entry.headline.replace(/<\/?[^>]+(>|$)/g, "").replace(/\u00a0/g, " ").replaceAll("&nbsp;","");
        }else if (entry.headline && entry.headline.text && entry.headline.text !== undefined && entry.headline.text !== ""){
          res = entry.headline.text.replace(/<\/?[^>]+(>|$)/g, "").replace(/\u00a0/g, " ").replaceAll("&nbsp;","");
        }else if (entry.name){
          res = entry.name.replace(/\u00a0/g, " ").replaceAll("&nbsp;","");
        }else if (entry.desc){
          res = entry.desc.replace(/\u00a0/g, " ").replaceAll("&nbsp;","");
        }else{
          res = "";
        }
        if (res.length > $scope.maxNameLen){
          res = res.substring(0, $scope.maxNameLen) + "...";
        }
        return stripHtml(res);
      };


      function stripHtml(html)
      {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
      }

      $scope.getTitleOrNameLength = function(entry) {
        var res = $scope.getTitleOrName(entry);
        return res.length;
      };

      $scope.getNameIfDifferent = function(entry) {
        var res;
        if (entry.name && entry.name !== $scope.getTitleOrName(entry)){
          res = entry.name.replace(/\u00a0/g, " ").replaceAll("&nbsp;","");
          if (res.length > $scope.maxNameLen) {
            res = stripHtml(res.substring(0, $scope.maxNameLen)) + "...";
          }
        }
        return res;
      };

      $scope.copy = function () {
        $scope.copying = true;
        return $scope.provider.getContentToPutInClipboard($scope.entry).then(function (content) {
          return ClipboardService.putInClipboard({data: content});
        }).finally(function() {
          $scope.copying = false;
        });
      };

      $scope.to_trusted = function (txt, limit, expand) {
        if (txt) {
          if (!expand && limit > 0) {
            txt = $filter('limitHtml')(txt, limit, "...");
          }
        }

        return $sce.trustAsHtml(String(txt));
      };

      $scope.isSourceVisible = function (txt) {
        return !!txt && ["ARCHIVE", "INCOMING", "CONTRIBUTORS"].includes(txt.toUpperCase());
      };

      $scope.isFieldSet = function (txt) {
        return txt !== "";
      };

      $scope.getFilteredSource = function (txt) {
        var result = "";
        if (txt) {
          if (txt.source) {
              result = txt.source;
          }
        }
        return result;
      };

      $scope.getFieldText = function (txt) {
        var result = "";
        if (txt !== "") {
            result = txt;
        }
        return result;
      };

      $scope.getFieldDate = function (date) {
        var result = "";
        if (date !== undefined) {
          var formattedDate = new Date(parseInt(date));
          var m = formattedDate.getMonth() + 1;
          result = " " + formattedDate.getDate() + "/" + m + "/" + formattedDate.getFullYear();
        }
        return result;
      };

    },

    link: function (scope, element) {
      function createDragUrl(entry) {
        if (!entry) {
          return;
        }
        var item = {
          contentid: entry.id,
          name: encodeURIComponent(entry.name),
          _type: entry._type,
          appName: entry.appName,
          thumbUrl: entry.thumbUrl !== undefined ? encodeURIComponent(entry.thumbUrl) : ""
        };

        var url = "dataapiurl=";
        if (!window.location.origin) {
          window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }

        url += window.location.origin;
        url += "/onecms/";
        url += "&contentlist=";
        url += JSON.stringify([item]);
        url += "&token=";
        url += Application.currentUser.token;
        return url;
      }

      function getText(entry) {
        var desc = entry.name;

        if ( !desc && entry.desc) {
          desc = entry.desc.substring(0, 49);
        }

        return desc;
      }

      element.on('dragstart', function (event) {
        $('.layout-preview-widget iframe').css('pointer-events', 'none');
        event.originalEvent.dataTransfer.setData('Text', createDragUrl(scope.entry));

        var e = event.originalEvent;
        e.dataTransfer.effectAllowed = 'copyMove';

        if (e.srcElement.parentNode) {
          var ghost = document.getElementById('drag-ghost-container');
          if (ghost && ghost.parentNode) {
            ghost.parentNode.removeChild(ghost);
          }

          var container = document.createElement('div');
          container.id = 'drag-ghost-container';

          var img = document.createElement('img');
          img.id = 'drag-ghost-widget';

          if(scope.entry.thumbUrl) {
            img.id = 'drag-ghost-img';
            img.src = scope.entry.thumbUrl;
          } else if('atex.dam.standard.Video' === scope.entry._type) {
            img.src = "img/video.png";
          } else if('atex.dam.standard.Embed' === scope.entry._type) {
            img.src = "img/embed.png";
          } else if('atex.onecms.image' === scope.entry._type) {
            img.src = "img/image.png";
          } else if ('atex.onecms.article' === scope.entry._type) {
            img.src = "img/article.png";
          } else {
            img.src = "img/generic.png";
          }

          var text = document.createElement('div');
          text.innerHTML = getText(scope.entry);
          text.id = 'drag-ghost-text';

          container.appendChild(img);
          container.appendChild(text);

          document.body.appendChild(container);
          e.dataTransfer.setDragImage(container, 0, 0);
        }
      });

      element.on('dragend', function () {
        $('.layout-preview-widget iframe').css('pointer-events', 'auto');
      });

    }
  };
}]);

angular.module('atex.art').directive('crossSearch', ['$http', '$compile', 'SearchService', '$q', 'CrossSearchService', 'AuthenticationService', '$templateCache',
  function ($http, $compile, SearchService, $q, CrossSearchService, AuthenticationService, $templateCache) {
    return {
      restrict: 'E',
      replace: true,
      template: [
        '<div class="navbar-form navbar-left cross-search" autocomplete="off" ng-submit="search();$event.stopPropagation();">',
        '<input ',
        'autocomplete="off" ',
        'type="text" ',
        'class="crossSearchPopover form-control" ',
        'placeholder="{{\'SEARCH\'|translate}}" ',
        'x-ng-model="model.fullTxt" ',
        'x-ng-model-options="{debounce:300}" ',
        'data-toggle="popover" ',
        'data-placement="bottom" ',
        '></div>'
      ].join(''),

      scope: true,

      controller: function ($scope, $compile, UserProfileService) {
        $scope.model = {
          fullTxt: ""
        };
        //Function to filter out unsplash search provider if it is disabled in the ui configuration
        function filterProviders(providers) {
          var promises = providers.map(function (provider) {
            return provider.isEnabled().then(function (enabled) {
              return enabled ? provider : undefined;
            });
          });

          return $q.all(promises).then(function(all) {
            return all.filter(function(p) {
              return p !== undefined;
            });
          });
        }

        CrossSearchService.getProviders().then(function (providers) {
          filterProviders(providers).then(function (filteredProviders) {
            $scope.providers = filteredProviders;
            $scope.currentProvider = $scope.providers[0];

            $scope.changeProvider = function (provider) {
              if (provider.id === $scope.currentProvider.id) {
                return;
              }
              $scope.currentProvider = provider;
              if (provider.lastSearch === $scope.model.fullTxt) {
                return;
              }
              $scope.search();
            };

            $('.crossSearchPopover').on('click', function (event) {
              if ($('.crossSearchPopover').next('div.popover:visible').length > 0) {
                event.preventDefault();
                event.stopImmediatePropagation();
              }
            });

            $('html').on('mousedown', function (event) {
              if (event.target.classList.contains('crossSearchPopover')) {
                return;
              }
              if ($(event.target).closest('.popover').length <= 0) {
                $('.crossSearchPopover').next('div.popover:visible').each(function () {
                  $(this).popover('hide');
                });
              }
            });
            var html = $templateCache.get("js/art/search/cross-search-popover.html");
            $scope.popOverContent = $compile(html)($scope);
          });
        });

      },

      link: function (scope, elem, attrs) {

        scope.$watch('popOverContent', function (newValue) {
          if (newValue) {
            elem.find('input').popover({
              html: true,
              content: scope.popOverContent
            });
          }
        });

        scope.$watch('model.fullTxt', function (newValue, oldValue) {
          if (newValue === oldValue) {
            return;
          }
          scope.search();
        });

        scope.close = function() {
          $('.crossSearchPopover').next('div.popover:visible').each(function () {
            $(this).popover('hide');
          });
        };

        scope.search = function (loadMore, refreshing) {
          if (!CrossSearchService.checkQueryString(scope.model.fullTxt)) {
            return;
          }
          scope.searching = true;
          scope.loadingMore = loadMore;
          scope.error = undefined;
          var start = 0;
          if (loadMore) {
            start = scope.currentProvider.results.length;
          }
          var keepFacet = loadMore || refreshing;
          return scope.currentProvider.search(scope.model.fullTxt.trim(), start, keepFacet).then(function (docs) {
            console.log("Found in " + scope.currentProvider.id + " results: " + docs.length);
          }).then(null, function (error) {
            scope.error = error;
          }).finally(function () {
            scope.searching = false;
            scope.loadingMore = false;
          });
        };

        scope.facet = function (fieldName, item, op) {
          scope.searching = true;
          scope.error = undefined;
          return scope.currentProvider.facetByItem(fieldName, item, op).then(null, function (error) {
            scope.error = error;
          }).finally(function () {
            scope.searching = false;
          });
        };

        scope.toggleAssignedToMe = function () {
          scope.searching = true;
          scope.error = undefined;
          return AuthenticationService.getCurrentUser().then(function (user) {
            return scope.currentProvider.toggleAssignedToMe(user.username);
          }).then(null, function (error) {
            scope.error = error;
          }).finally(function () {
            scope.searching = false;
          });
        };

        scope.toggleExtraFilter = function (extra) {
          scope.searching = true;
          scope.error = undefined;
          return scope.currentProvider.toggleExtraFilter(extra).then(null, function (error) {
            scope.error = error;
          }).finally(function () {
            scope.searching = false;
          });
        };

        scope.toggleSort = function (sort) {
          scope.searching = true;
          scope.error = undefined;
          return scope.currentProvider.toggleSort(sort).then(null, function (error) {
            scope.error = error;
          }).finally(function () {
            scope.searching = false;
          });
        };

        scope.clear = function () {
          scope.model.fullTxt = "";
          return scope.providers.forEach(function (provider) {
            provider.clear();
          });
        };
      }
    };
  }
]);
